export const shouldShowDojoNudge = ({ statusLoaded, inDojo }) => (
  statusLoaded === true && inDojo === false
);
